export const BUTTON_SHADOW_IDLE = '0 0 3px 2px rgba(43,18,2,0.07)';
export const BUTTON_SHADOW_HOVERED = '0 0 10px 2px rgba(43,18,2,0.20)';
